import { postApi } from './resonanceApi';
import { AxiosResponse } from 'axios';
import axios from 'axios';
import { ENV } from '../environments/environment';

// Define the email endpoint as a constant
const SEND_EMAIL_URL = 'email/send';

export interface SendEmailPayload {
  template: string;
  from?: string;
  to: string[];
  lang: string;
  params: Record<string, unknown>;
  studyId?: number;
}

export interface SendEmailAttachment {
  file: File;
}

export const sendEmail = (body: SendEmailPayload): Promise<AxiosResponse<{ message: string }>> => {
  return postApi(SEND_EMAIL_URL, {}, body);
};

export const sendEmailWithAttachments = (
  body: SendEmailPayload,
  attachments: SendEmailAttachment[]
): Promise<AxiosResponse<{ message: string }>> => {
  const formData = new FormData();

  formData.append('template', body.template);
  if (body.from) formData.append('from', body.from);
  formData.append('to', JSON.stringify(body.to));
  formData.append('lang', body.lang);
  formData.append('params', JSON.stringify(body.params));
  if (body.studyId !== undefined) {
    formData.append('studyId', String(body.studyId));
  }

  attachments.forEach(({ file }) => {
    formData.append('attachments', file, file.name);
  });

  return axios.post<{ message: string }>(`${ENV.REACT_APP_BASE_URL}/${SEND_EMAIL_URL}`, formData);
};
